import React, { Component } from "react";
import { FormProps, FormState, IPForm, sortRVXLookups } from "./index";
import { RVEnvironment, RVMode, RVPicketItem, RVPropertyType, SearchOption } from "../../../api/entities";
import * as RVApi from "../../../api/api";
import { RVLookupX } from "../../../api/api";
import { NullHandler } from "@my-dld/utils/ApiUtils";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import { checkNonEmpty } from "@eres/ejari-web/utils";
import { ErrorContainer } from "@eres/forms";
import PickerInput from "@my-dld/components/Form/PickerInput";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil } from "@eres/core";
import TextInputField from "@my-dld/components/Form/TextInputField";

interface State extends FormState {
	number?: string;
	subNo?: string;
	areas?: RVLookupX[];
	area?: RVLookupX;
	building?: string;
	unit?: string;
	hasBuilding?: boolean;
	hasUnit?: boolean;
}

export class LandForm extends Component<FormProps, State> implements IPForm {
	apiHandler: any;
	apiExHandler: any;

	constructor( props: FormProps ) {
		super( props );
		this.state = {
			errorContainer: {},
			hasBuilding: this.props.env.propertyType === RVPropertyType.BUILDING || this.props.env.propertyType === RVPropertyType.VILLA || this.props.env.propertyType === RVPropertyType.UNIT,
			hasUnit: this.props.env.propertyType === RVPropertyType.UNIT,
		};
	}

	static getDerivedStateFromProps( nextProps: Readonly<FormProps>, prevState: State ): Partial<State> {
		let propertyType = nextProps.env.propertyType;
		const update: Partial<State> = {
			hasBuilding: propertyType === RVPropertyType.BUILDING || propertyType === RVPropertyType.VILLA || propertyType === RVPropertyType.UNIT,
			hasUnit: propertyType === RVPropertyType.UNIT,
		};
		return update;
	}

	updateParams( opts: SearchOption, env: RVEnvironment ): void {
		const { hasBuilding, hasUnit } = this.state;
		opts.landNo = this.state.number;
		opts.landSubNo = this.state.subNo;
		opts.areaId = Number( this.state.area! );
		if ( hasBuilding ) {
			opts.buildingName = this.state.building;
		}
		if ( hasUnit ) {
			opts.propertyNumber = this.state.unit;
		}
	}

	validate( opts: SearchOption, env: RVEnvironment ): boolean {
		const { hasBuilding, hasUnit } = this.state;
		let isValid: boolean = true;
		let error: ErrorContainer = {};
		isValid = checkNonEmpty( this.state, "area", error ) && isValid;
		isValid = checkNonEmpty( this.state, "number", error ) && isValid;
		if ( hasBuilding && env.propertyType === RVPropertyType.UNIT ) {
			isValid = checkNonEmpty( this.state, "building", error ) && isValid;
		}
		this.setState( {
			errorContainer: error,
		} );
		return isValid;
	}

	componentDidUpdate( prevProps: Readonly<FormProps>, prevState: Readonly<State>, snapshot?: any ) {
		if ( prevProps && prevProps.env.mode !== this.props.env.mode ) {
			this.loadAreas();
		}
	}

	componentDidMount() {
		this.loadAreas();
	}

	componentWillUnmount() {
		this.apiHandler = NullHandler;
		this.apiExHandler = NullHandler;
	}

	loadAreas() {
		let p = "";
		showLoading();
		if ( this.props.env.mode === RVMode.OWN && this.props.env.participantId ) {
			p = this.props.env.participantId + "";
		}
		this.apiHandler = ( resp: RVLookupX[] ) => {
			hideLoading();
			this.setState( {
				areas: resp ? sortRVXLookups( resp ) : [],
			} );
		};
		this.apiExHandler = ( reason: any ) => {
			hideLoading();
			if ( reason && reason.type && reason.type === "ValidationError" ) {
				showMessage( reason.message );
			} else {
				showMessage( reason.toString() );
			}
		};
		RVApi.loadLookupsX( "area", p )
		.then( RVApi.validateResponseX )
		.then( this.apiHandler )
		.catch( this.apiExHandler );
	}

	render() {
		const kvProp = { inputClassName: "form-control", holder: this, containerClassName: "col-md-6 form-group" };
		const { areas, area, hasBuilding, hasUnit, errorContainer } = this.state;
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-md-4">
						<PickerInput
							{ ...kvProp }
							label={ Strings.area }
							id={ "area" }
							items={ areas }
							formatter={ item => LocaleUtil.getLocalValue( item ) }
							toIdentifier={ ( item: RVPicketItem ) => item.Identity + "" }
							containerClassName="form-group field-style select-control"
							required={ true }
							error={ errorContainer.area }
						/>
					</div>
					{
						area &&
						<React.Fragment>
							<div className="col-md-4">
								<TextInputField
									{ ...kvProp }
									id={ "number" }
									required={ true }
									label={ Strings.land_number }
									containerClassName="form-group"
									error={ errorContainer.number }
								/>
							</div>
							<div className="col-md-4">
								<TextInputField
									{ ...kvProp }
									id={ "subNo" }
									required={ true }
									label={ Strings.land_sub }
									containerClassName="form-group"
									error={ errorContainer.subNo }
								/>
							</div>
							{
								hasBuilding &&
								<div className="col-md-4">
									<TextInputField
										{ ...kvProp }
										id={ "building" }
										required={ true }
										label={ Strings.building_name }
										containerClassName="form-group"
										error={ errorContainer.building }
									/>
								</div>
							}
							{
								hasUnit &&
								<div className="col-md-4">
									<TextInputField
										{ ...kvProp }
										id={ "unit" }
										required={ true }
										label={ Strings.unitNo }
										containerClassName="form-group"
										error={ errorContainer.unit }
									/>
								</div>
							}
						</React.Fragment>
					}
				</div>
			</React.Fragment>
		);
	}

}
